export default "__VITE_ASSET__BgxIQTQ7__"